module.exports = __webpack_public_path__ + "static/media/checked.88718607.svg";